import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ProtoplanLogoText from '../images/logo_text.svg';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import {
  FUNDRAISERS,
  ACCOUNT,
  HOME,
  LOGIN,
  PROTOCOL,
  WHO as ABOUT_WHO,
  PLANS as ABOUT_PLANS,
  INVESTING as BLOG_INVESTING,
  MM_INDEX,
  WHY as ABOUT_WHY,
  BLOG,
  ABOUT,
  MM_PROTOCOL,
  PROTOCOL_BUILDER} from '../core/router/paths';
import { IState } from '../core/store/store';
import { useSelector } from 'react-redux';
import React, { useRef, useEffect } from 'react';
import { AppBar, Toolbar, Box, IconButton, Typography, Link, Stack, Grid } from '@mui/material';
import PatreonIcon from '../images/patreon.svg';


type TLinkEl = React.MutableRefObject<HTMLAnchorElement | null>;


const Header: React.FC = () =>
{
  const user = useSelector((state: IState) => state.user);
  const fundraisersLink = useRef<HTMLAnchorElement|null>(null);
  const blogLink = useRef<HTMLAnchorElement|null>(null);
  const aboutLink = useRef<HTMLAnchorElement|null>(null);
  const userLink = useRef<HTMLAnchorElement|null>(null);
  const loginLink = useRef<HTMLAnchorElement|null>(null);
  const mmIndexLink = useRef<HTMLAnchorElement|null>(null);
  const protocolLink = useRef<HTMLAnchorElement|null>(null);
  const mmProtocolsLink = useRef<HTMLAnchorElement|null>(null);
  const protocolBuilderLink = useRef<HTMLAnchorElement|null>(null);

  const pathname = useLocation().pathname;
  const linkElems = [
    fundraisersLink,
    blogLink,
    aboutLink,
    userLink,
    loginLink,
    mmIndexLink,
    protocolLink,
    mmProtocolsLink,
    protocolBuilderLink];

  useEffect(() =>
  {
    const formatLink = (el: TLinkEl, clickedEl: TLinkEl | null) =>
    {
      if(!el?.current)
        return;

      el.current.style.fontWeight = (clickedEl && el === clickedEl) ? '700' : '450';
    };

    if(pathname.includes(PROTOCOL + "/"))
      return linkElems.forEach(el => formatLink(el, protocolLink));
    else if(pathname.includes(MM_PROTOCOL))
      return linkElems.forEach(el => formatLink(el, mmProtocolsLink));

    switch(pathname)
    {
    case FUNDRAISERS:
      linkElems.forEach(el => formatLink(el, fundraisersLink));
      break;
    case BLOG + "/" + BLOG_INVESTING:
      linkElems.forEach(el => formatLink(el, blogLink));
      break;
    case ABOUT + "/" + ABOUT_WHY:
    case ABOUT + "/" + ABOUT_WHO:
    case ABOUT + "/" + ABOUT_PLANS:
      linkElems.forEach(el => formatLink(el, aboutLink));
      break;
    case ACCOUNT:
      linkElems.forEach(el => formatLink(el, userLink));
      break;
    case LOGIN:
      linkElems.forEach(el => formatLink(el, loginLink));
      break;
    case MM_INDEX:
      linkElems.forEach(el => formatLink(el, mmIndexLink));
      break;
    case PROTOCOL_BUILDER:
      linkElems.forEach(el => formatLink(el, protocolBuilderLink));
      break;
    default:
      linkElems.forEach(el => formatLink(el, null));
    }
  });

  return (
    <>
      <AppBar
        style={{
          position: 'relative',
          boxShadow:
            '0px 2px 4px -1px rgb(0 0 0 / 7%), ' +
            '0px 4px 5px 0px rgb(0 0 0 / 7%), ' +
            '0px 1px 10px 0px rgb(0 0 0 / 4%)' }}>

        <Toolbar
          sx={{ pt: 1 }}
          style={{ backgroundColor: 'white', color: 'black' }}>

          <Link
            variant='h4'
            sx={{ color: 'black', flexGrow: 1 }}
            underline='none'
            to={HOME}
            component={RouterLink}>
            <ProtoplanLogoText/>
          </Link>

          <Box sx={{ width: 90 }}>
            <Link
              variant='subtitle2'
              sx={{ color: 'rgb(0,0,0)' }}
              underline='none'
              component={RouterLink}
              to={PROTOCOL}
              ref={protocolLink}>
              Protocols
            </Link>
          </Box>

          {Number(process.env.MM_PROTOCOLS) ?
            <>
              <Box sx={{ width: 120 }}>
                <Link
                  variant='subtitle2'
                  sx={{ color: 'rgb(0,0,0)' }}
                  underline='none'
                  component={RouterLink}
                  to={MM_PROTOCOL}
                  ref={mmProtocolsLink}>
                  MM Protocols
                </Link>
              </Box>

              <Box sx={{ width: 120 }}>
                <Link
                  variant='subtitle2'
                  sx={{ color: 'rgb(0,0,0)' }}
                  underline='none'
                  component={RouterLink}
                  to={PROTOCOL_BUILDER}
                  ref={protocolBuilderLink}>
                  Protocol Builder
                </Link>
              </Box>
            </> :
            <></>}

          <Box sx={{ width: 90 }}>
            <Link
              variant='subtitle2'
              sx={{ color: 'rgb(0,0,0)' }}
              underline='none'
              component={RouterLink}
              to={MM_INDEX}
              ref={mmIndexLink}>
              MM Index
            </Link>
          </Box>

          <Box sx={{ width: 100 }}>
            <Link
              variant='subtitle2'
              sx={{ color: 'rgb(0,0,0)' }}
              underline='none'
              component={RouterLink}
              to={FUNDRAISERS}
              ref={fundraisersLink}>
              Fundraisers
            </Link>
          </Box>

          {/*<Box sx={{ width: 60 }}>
            <Link
              variant='subtitle2'
              sx={{ color: 'rgb(0,0,0)' }}
              underline='none'
              component={RouterLink}
              to={BLOG + "/" + BLOG_INVESTING}
              ref={blogLink}>
              Blog
            </Link>
          </Box>

          <Box sx={{ width: 60 }}>
            <Link
              variant='subtitle2'
              sx={{ color: 'rgb(0,0,0)' }}
              underline='none'
              component={RouterLink}
              to={ABOUT + "/" + ABOUT_WHY}
              ref={aboutLink}>
              About
            </Link>
          </Box>*/}

          {!user.premium ?
            <Link
              variant='body2'
              target='_blank'
              rel='noreferrer'
              href={"https://www.patreon.com/Protoplan/"} >
              <Stack direction={'row'} spacing={1} sx={{ width: 150 }}>
                <Grid item xs style={{ display: "flex", paddingTop: '17px' }}>
                  <PatreonIcon/>
                </Grid>
                <Typography variant={'body2'} sx={{ fontSize: 12, pb: 1 }}>
                  {"NEW: Support Protoplan on Patreon for premium features!"}
                </Typography>
              </Stack>
            </Link>:
            <></>}


          {user.username ?
            (<Box sx={{ width: 135, textAlign: 'right', wordWrap: 'break-word' }}>
              <Link
                id='Account'
                variant='subtitle2'
                sx={{ color: 'black' }}
                component={RouterLink}
                to={ACCOUNT}
                underline='none'
                ref={userLink}>
                {user.username}
              </Link>
              <IconButton
                size='small'
                color='inherit'
                component={RouterLink}
                to={ACCOUNT}>
                <AccountCircleIcon fontSize='large' htmlColor='#b3b3b3' />
              </IconButton>
            </Box>) :
            (<Box sx={{ width: 135, textAlign: 'right' }}>
              <Link
                id='Login'
                variant='subtitle2'
                sx={{ color: 'black' }}
                underline='none'
                position='relative'
                to={LOGIN}
                component={RouterLink}
                ref={loginLink}>
                Log in
              </Link>
            </Box>)}
        </Toolbar>
      </AppBar>

      {/android|iphone|kindle|ipad/i.test(navigator.userAgent) ?
        <Box sx={{ display: 'flex', justifyContent: 'center', pt: 2 }}>
          <Typography variant='h4'>
            Warning: Not yet optimised for mobile browsers!
          </Typography>
        </Box> :
        <></>}
    </>);
};

export default Header;
